import React from "react";
import PropTypes from "prop-types";

import "./style.scss";

const Button = ({
  value,
  handleClick,
  disabled,
  formId,
  newDesign,
  customClass,
}) => {
  const type = formId !== "" ? "submit" : "button";
  const args = type === "submit" ? {form: formId} : {};
  const buttonStyle = newDesign ? "new-button-design" : "old-button-design";
  const disabledClass = disabled ? "disabled-btn" : null;
  const classNames = [customClass, "button-base", buttonStyle, disabledClass]
    .filter((a) => a)
    .join(" ");
  return (
    <button
      type={type}
      className={classNames}
      onClick={handleClick}
      disabled={disabled}
      {...args}
    >
      {value}
    </button>
  );
};

Button.propTypes = {
  customClass: PropTypes.string,
  disabled: PropTypes.bool,
  formId: PropTypes.string,
  handleClick: PropTypes.func,
  newDesign: PropTypes.bool,
  value: PropTypes.string,
};

Button.defaultProps = {
  disabled: false,
  formId: "",
  handleClick: () => {},
  newDesign: false,
};

export default Button;
